import React, { useEffect, useState, useRef } from "react";

const TERMIN_ORTE = ["Praxis", "Kindergarten", "Schule", "Pflegeeinrichtung", "Hausbesuch"];
const VO_OPTIONS = ["Nein", "Ja", "wird ausgestellt, wenn Termin"];
const WUNSCH_OPTIONS = ["Vormittag", "Nachmittag", "ab Uhr", "flexibel"];
const TEL_TYPES = ["Mobil", "Festnetz"];

const EMPTY = {
  name: "",
  geburtsdatum: "",
  krankenkasse: "",
  adresse: "",
  telefon: "",
  telTyp: "",
  arzt: "",
  voVorhanden: "",
  stoerungsbild: "",
  seit: "",
  terminOrt: "",
  einrichtung: "",
  gruppe: "",
  wunschtermin: "",
  wunschUhr: "",
  sonstiges: "",
  consent: false,
  website: "",
};

function ContactForm({ isMobile }) {
  const [values, setValues] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const t0Ref = useRef(null);

  useEffect(() => {
    if (t0Ref.current === null) {
      t0Ref.current = Date.now();
    }
  }, []);

  const set = (field) => (e) => {
    const v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setValues((prev) => ({ ...prev, [field]: v }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      ["name", values.name, "f-name"],
      ["geburtsdatum", values.geburtsdatum, "f-geb"],
      ["krankenkasse", values.krankenkasse, "f-kk"],
      ["telefon", values.telefon, "f-tel"],
      ["arzt", values.arzt, "f-arzt"],
      ["stoerungsbild", values.stoerungsbild, "f-st"],
    ];
    for (const [, v, id] of requiredFields) {
      if (!v || String(v).trim() === "") {
        const el = document.getElementById(id);
        if (el && el.focus) {
          el.focus();
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
    }
    if (!values.consent) return;

    setStatus("sending");

    const fd = new FormData();
    Object.entries(values).forEach(([k, v]) =>
      fd.append(k, typeof v === "boolean" ? (v ? "on" : "") : v)
    );
    fd.append("t0", String(t0Ref.current ?? Date.now()));

    try {
      const res = await fetch("/send-mail.php", { method: "POST", body: fd });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok === true) {
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch (_err) {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className={isMobile ? "formularBoxMobile" : "formularBox"}>
        <div className="formularSuccess">
          <strong>Vielen Dank für Ihre Anfrage.</strong>
          <div style={{ marginTop: "8px" }}>
            Wir melden uns innerhalb weniger Werktage bei Ihnen.
          </div>
        </div>
      </div>
    );
  }

  const subbanner = isMobile ? "formularSubbannerMobile" : "formularSubbanner";
  const box = isMobile ? "formularBoxMobile" : "formularBox";

  return (
    <form className={box} onSubmit={handleSubmit} noValidate>
      <input
        type="text"
        name="website"
        className="formularHoneypot"
        tabIndex={-1}
        autoComplete="off"
        value={values.website}
        onChange={set("website")}
        aria-hidden="true"
      />

      <div className={subbanner}>Persönliche Angaben</div>

      {isMobile ? (
        <>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-name">Name *</label>
            <input id="f-name" className="formularInput" type="text" required autoComplete="name"
                   value={values.name} onChange={set("name")} />
          </div>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-geb">Geburtsdatum *</label>
            <input id="f-geb" className="formularInput" type="date" required
                   value={values.geburtsdatum} onChange={set("geburtsdatum")} />
          </div>
        </>
      ) : (
        <div className="formularGrid2">
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-name">Name *</label>
            <input id="f-name" className="formularInput" type="text" required autoComplete="name"
                   value={values.name} onChange={set("name")} />
          </div>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-geb">Geburtsdatum *</label>
            <input id="f-geb" className="formularInput" type="date" required
                   value={values.geburtsdatum} onChange={set("geburtsdatum")} />
          </div>
        </div>
      )}

      <div className="formularRow">
        <label className="formularLabel" htmlFor="f-kk">Krankenkasse *</label>
        <input id="f-kk" className="formularInput" type="text" required
               value={values.krankenkasse} onChange={set("krankenkasse")} />
      </div>

      <div className="formularRow">
        <label className="formularLabel" htmlFor="f-adr">Adresse</label>
        <textarea id="f-adr" className="formularTextarea" rows={2}
                  value={values.adresse} onChange={set("adresse")} />
      </div>

      {isMobile ? (
        <>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-tel">Telefonnummer *</label>
            <input id="f-tel" className="formularInput" type="tel" required autoComplete="tel"
                   value={values.telefon} onChange={set("telefon")} />
          </div>
          <div className="formularRow">
            <span className="formularLabel">Mobil / Festnetz</span>
            <div className="formularRadioGroup">
              {TEL_TYPES.map((t) => (
                <label key={t}>
                  <input type="radio" name="telTyp" value={t}
                         checked={values.telTyp === t} onChange={set("telTyp")} /> {t}
                </label>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="formularGrid2">
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-tel">Telefonnummer *</label>
            <input id="f-tel" className="formularInput" type="tel" required autoComplete="tel"
                   value={values.telefon} onChange={set("telefon")} />
          </div>
          <div className="formularRow">
            <span className="formularLabel">Mobil / Festnetz</span>
            <div className="formularRadioGroup">
              {TEL_TYPES.map((t) => (
                <label key={t}>
                  <input type="radio" name="telTyp" value={t}
                         checked={values.telTyp === t} onChange={set("telTyp")} /> {t}
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className={subbanner}>Verordnung &amp; Störungsbild</div>

      <div className="formularRow">
        <label className="formularLabel" htmlFor="f-arzt">Verordnender Arzt *</label>
        <input id="f-arzt" className="formularInput" type="text" required
               value={values.arzt} onChange={set("arzt")} />
      </div>

      <div className="formularRow">
        <span className="formularLabel">VO vorhanden</span>
        <div className="formularRadioGroup">
          {VO_OPTIONS.map((v) => (
            <label key={v}>
              <input type="radio" name="voVorhanden" value={v}
                     checked={values.voVorhanden === v} onChange={set("voVorhanden")} /> {v}
            </label>
          ))}
        </div>
      </div>

      <div className="formularRow">
        <label className="formularLabel" htmlFor="f-st">Störungsbild *</label>
        <textarea id="f-st" className="formularTextarea" rows={3} required
                  value={values.stoerungsbild} onChange={set("stoerungsbild")} />
      </div>

      <div className="formularRow" style={isMobile ? {} : { maxWidth: "260px" }}>
        <label className="formularLabel" htmlFor="f-seit">Seit</label>
        <input id="f-seit" className="formularInput" type="text"
               placeholder="z. B. 3 Jahre, Januar 2024"
               value={values.seit} onChange={set("seit")} />
      </div>

      <div className={subbanner}>Wunschtermin</div>

      <div className="formularRow">
        <span className="formularLabel">Termin erwünscht in</span>
        <div className="formularRadioGroup">
          {TERMIN_ORTE.map((o) => (
            <label key={o}>
              <input type="radio" name="terminOrt" value={o}
                     checked={values.terminOrt === o} onChange={set("terminOrt")} /> {o}
            </label>
          ))}
        </div>
      </div>

      {isMobile ? (
        <>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-einr">Name / Ort der Einrichtung</label>
            <input id="f-einr" className="formularInput" type="text"
                   value={values.einrichtung} onChange={set("einrichtung")} />
          </div>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-gr">Gruppe / Klasse / Zimmer</label>
            <input id="f-gr" className="formularInput" type="text"
                   value={values.gruppe} onChange={set("gruppe")} />
          </div>
        </>
      ) : (
        <div className="formularGrid2">
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-einr">Name / Ort der Einrichtung</label>
            <input id="f-einr" className="formularInput" type="text"
                   value={values.einrichtung} onChange={set("einrichtung")} />
          </div>
          <div className="formularRow">
            <label className="formularLabel" htmlFor="f-gr">Gruppe / Klasse / Zimmer</label>
            <input id="f-gr" className="formularInput" type="text"
                   value={values.gruppe} onChange={set("gruppe")} />
          </div>
        </div>
      )}

      <div className="formularRow">
        <span className="formularLabel">Wunschtermin</span>
        <div className="formularRadioGroup">
          {WUNSCH_OPTIONS.map((w) => (
            <label key={w}>
              <input type="radio" name="wunschtermin" value={w}
                     checked={values.wunschtermin === w} onChange={set("wunschtermin")} />
              {" "}{w === "ab Uhr" ? "ab" : w}
              {w === "ab Uhr" && (
                <input type="time" className="formularInput" style={{ marginLeft: "6px" }}
                       value={values.wunschUhr} onChange={set("wunschUhr")}
                       disabled={values.wunschtermin !== "ab Uhr"} />
              )}
              {w === "ab Uhr" && " Uhr"}
            </label>
          ))}
        </div>
      </div>

      <div className="formularRow">
        <label className="formularLabel" htmlFor="f-son">Sonstiges</label>
        <textarea id="f-son" className="formularTextarea" rows={3}
                  value={values.sonstiges} onChange={set("sonstiges")} />
      </div>

      <div className="formularConsent">
        <label>
          <input type="checkbox" required
                 checked={values.consent} onChange={set("consent")} />{" "}
          Ich habe die <a href="/Dsgvo">Datenschutzerklärung</a> gelesen und willige in die
          Verarbeitung meiner Daten zur Bearbeitung meiner Anfrage ein. *
        </label>
      </div>

      {status === "error" && (
        <div className="formularError" role="alert">
          <strong>Beim Senden ist ein Fehler aufgetreten.</strong>{" "}
          Bitte versuchen Sie es später erneut oder rufen Sie uns unter{" "}
          <strong>06165/3637</strong> an.
        </div>
      )}

      <button type="submit"
              className="formularSubmit"
              disabled={!values.consent || status === "sending"}>
        {status === "sending" ? "Wird gesendet…" : "Absenden"}
      </button>
    </form>
  );
}

export default ContactForm;
